// extracted by mini-css-extract-plugin
export default {"modal":"CU-z","error":"DU-z","disabled":"EU-z","fields":"FU-z","errorMsg":"GU-z","footer":"HU-z","formContentWrapper":"IU-z","productImage":"JU-z","overlay":"KU-z"};